module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/BMWTypeNextPro-Light.woff?6c281711470ebbc910b8a7e856ad1bb2";